var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._b(
      {
        staticClass: "rb-color-facet",
        class: {
          "rb-color-facet--hover": _vm.isHover,
          "rb-color-facet--active": _vm.active,
          "rb-color-facet--disabled": _vm.disabled,
        },
        attrs: { tabindex: _vm.tabindex },
        on: {
          click: _vm.onFacetClick,
          mouseover: function ($event) {
            _vm.isHover = true
          },
          mouseleave: function ($event) {
            _vm.isHover = false
          },
        },
      },
      "button",
      _vm._d({}, [_vm.dataMntName, _vm.dataMntContent])
    ),
    [
      _c("rb-lazy-icon", {
        staticClass: "rb-color-facet__color",
        attrs: { text: _vm.icon, icon: _vm.icon },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "rb-color-facet__details" }, [
        _c(
          "span",
          {
            staticClass: "rb-color-facet__label",
            class: [_vm.hasNoSpace ? "--ellipsis" : "--vertical-clamp"],
          },
          [_vm._v(_vm._s(_vm.label))]
        ),
        _vm._v(" "),
        _vm.showFacetCount
          ? _c("span", { staticClass: "rb-color-facet__count" }, [
              _vm._v("(" + _vm._s(_vm.count) + ")"),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }